<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    {{ 'CRM.ASSOCIATION_PANEL.PARTNER_INFORMATION.TITLE' | translate }}
  </mat-expansion-panel-header>
  <ng-container *ngIf="isLoading(); else content">
    <glxy-loading-spinner></glxy-loading-spinner>
  </ng-container>
  <ng-template #content>
    <ng-container *ngIf="partnerInfo(); else createPartnerButton">
      <div class="partner-information">
        <div *ngIf="partnerInfo().partnerId">
          <span class="partner-information--label">{{
            'SUPERADMIN.CREATE_PARTNER.PARTNER_DETAILS.ID' | translate
          }}</span>
          <div class="partner-information--field">
            <p class="partner-information--id" (click)="copyToClipboard(partnerInfo().partnerId)">
              {{ partnerInfo().partnerId }}
              <mat-icon class="copy-icon">content_copy</mat-icon>
            </p>
            <div class="partner-information-icons">
              <a (click)="editPartnerID(partnerInfo().partnerId, partnerInfo().name, partnerInfo().accountGroupId)">
                <mat-icon class="edit-pid-link"> edit </mat-icon>
              </a>
              <a mat-icon-button href="/?_pid={{ partnerInfo().partnerId }}">
                <mat-icon color="primary">person</mat-icon>
              </a>
            </div>
          </div>
        </div>
        <div *ngIf="partnerInfo().subscriptionTierId">
          <span class="partner-information--label">{{ 'PARTNER_SUBSCRIPTIONS.SUBSCRIPTION_TITLE' | translate }}</span>
          <div class="partner-information--field">
            <span>{{ partnerInfo().subscriptionTierId }}</span>
          </div>
        </div>
        <div *ngIf="partnerInfo().health">
          <span class="partner-information--label">{{
            'CRM.ASSOCIATION_PANEL.PARTNER_INFORMATION.FINANCIAL_HEALTH' | translate
          }}</span>
          <div class="partner-information--financial">
            <mat-icon fontIcon="lens" class="{{ partnerInfo().health.iconCss }}"></mat-icon>
            {{ partnerInfo().health.displayState | translate }}
            {{ partnerInfo().health.displaySubState | translate }}
          </div>
        </div>
        <div *ngIf="partnerInfo().partnerId && partnerInfo().health">
          <a href="/superadmin/financial-health/{{ partnerInfo().partnerId }}" class="partner-information--link">
            {{ 'COMMON.ACTION_LABELS.VIEW_DETAILS' | translate }}
          </a>
        </div>
        <div *ngIf="partnerInfo().partnerId && partnerInfo().health">
          <a (click)="goToPricing()" class="partner-information--link">
            {{ 'CRM.ASSOCIATION_PANEL.PARTNER_INFORMATION.BILLING_CENTER' | translate }}
            <mat-icon color="primary" class="partner-information--link-token">open_in_new</mat-icon>
          </a>
        </div>
      </div>
    </ng-container>
  </ng-template>
</mat-expansion-panel>

<ng-template #createPartnerButton>
  <ng-container
    *ngTemplateOutlet="createPartnerButtonTemplate; context: { loading: createPartnerButtonLoading$ | async }"
  ></ng-container>
</ng-template>

<ng-template #createPartnerButtonTemplate let-loading="loading">
  <glxy-button-group>
    <button
      class="create-button"
      mat-stroked-button
      color="primary"
      type="button"
      (click)="createPartner()"
      [disabled]="loading"
    >
      <glxy-button-loading-indicator [isLoading]="loading">
        {{ 'CRM.ASSOCIATION_PANEL.PARTNER_INFORMATION.CREATE_PARTNER' | translate }}
      </glxy-button-loading-indicator>
    </button>
    <button
      class="dropdown-icon"
      mat-stroked-button
      [matMenuTriggerFor]="otherOptions"
      color="primary"
      [disabled]="loading"
    >
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </glxy-button-group>

  <mat-menu #otherOptions="matMenu">
    <button mat-menu-item (click)="editPartnerID('', companyInfo().name, companyInfo().accountGroupId)">
      {{ 'CRM.ASSOCIATION_PANEL.PARTNER_INFORMATION.ASSOCIATE_WITH_PARTNER' | translate }}
    </button>
  </mat-menu>
</ng-template>
